var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isOldAndroid
    ? _c("div", { staticClass: "lc-audio" }, [
        _c("div", { staticClass: "lc-audio__player lc-container" }, [
          _c("div", { staticClass: "lc-audio__control" }, [
            _vm.paused && !_vm.complete
              ? _c(
                  "button",
                  {
                    staticClass: "mdc-button mdc-button--icon",
                    on: { click: _vm.play }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("play_arrow")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.complete
              ? _c(
                  "button",
                  {
                    staticClass: "mdc-button mdc-button--icon",
                    on: { click: _vm.replay }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("replay")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.playing && !_vm.complete
              ? _c(
                  "button",
                  {
                    staticClass: "mdc-button mdc-button--icon",
                    on: { click: _vm.pause }
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("pause")
                    ])
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "lc-audio__playback-time",
              on: { click: _vm.setPosition }
            },
            [
              _c("span", {
                staticClass: "lc-audio__playback-time-indicator",
                style: _vm.progressStyle
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "lc-audio__time" }, [
            _c("span", { staticClass: "lc-audio__time-current" }, [
              _vm._v("\n        " + _vm._s(_vm.current) + "\n      ")
            ]),
            _vm._v(" |\n      "),
            _c("span", { staticClass: "lc-audio__time-total" }, [
              _vm._v("\n        " + _vm._s(_vm.duration) + "\n      ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("audio", {
          ref: "audiofile",
          staticStyle: { display: "none" },
          attrs: { src: _vm.file, preload: "auto" }
        })
      ])
    : _c("div", { staticClass: "lc-container" }, [
        _c("audio", {
          ref: "audiofile",
          attrs: { controls: "", src: _vm.file, preload: "auto" }
        })
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61693b1f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61693b1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LcAudio.vue
// module id = TKkL
// module chunks = 1